// import React, { useEffect, useState, useCallback } from 'react';
// import axios from 'axios';
// import {
//   Box, Typography, IconButton,
// } from '@mui/material';
// import { Visibility } from '@mui/icons-material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';
// import { useTranslation } from 'react-i18next';
// import i18next from 'i18next';
// import { AFEViewModal } from './assignedFEModal';

// export const AssignedFinancialEstablishmentComponent = () => {
//   const { t, i18n } = useTranslation();

//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   // Modal state
//   const [viewModalOpen, setViewModalOpen] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [modalLoading, setModalLoading] = useState(false);

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: t('assignedFE.slNo'), width: 50 },
//     { id: 'nameOfCA', field: 'nameOfCA', headerName: t('assignedFE.nameOfCA'), width: 150 },
//     { id: 'designation', field: 'designation', headerName: t('assignedFE.designation'), width: 150 },
//     { id: 'caAddress', field: 'caAddress', headerName: t('assignedFE.caAddress'), width: 250 },
//     { id: 'nameOfTheFe', field: 'nameOfTheFe', headerName: t('assignedFE.assignedFE'), width: 250 },
//     { id: 'phNo', field: 'phNo', headerName: t('assignedFE.phNo'), width: 100 },
//     { id: 'emailLink', field: 'emailLink', headerName: t('assignedFE.email'), width: 180 },
//     {
//       id: 'viewDetails',
//       field: 'viewDetails',
//       headerName: t('assignedFE.viewDetails'),
//       width: 120,
//       renderCell: (params) => (
//         <IconButton
//           size="small"
//           color="primary"
//           onClick={() => handleViewDetails(params.row)}
//         >
//           <Visibility />
//         </IconButton>
//       ),
//     },
//   ];

//   const fetchAssignedFE = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(`${API_BASE_URL}/home-notification/assignedfe/`, {
//         params: { language: i18n.language}
//       });
      
//       const apiData = response.data.map((item, index) => ({
//         id: item.id || index,
//         slNo: index + 1,
//         nameOfCA: item.name_of_ca,
//         designation: item.designation,
//         caAddress: item.ca_address || '',
//         nameOfTheFe: item.name_of_fe,
//         phNo: item.ph_number,
//         emailLink: item.email,
//         groupOfEntities: item.group_of_entities || '',
//         nameOfDirectors: item.name_of_directors || '',
//         crimeNo: item.crime_no || '',
//         firNo: item.fir_no || '',
//         companyEmail: item.company_email || '',
//         companyPhNumber: item.company_ph_number || '',
//         addressOfCompany: item.address_of_company || '',
//         viewDetailsLink: item.link || '',
//       }));
      
//       setRows(apiData);
//       setSnackbarMessage(t('assignedFE.successMessage'));
//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//     } catch (error) {
//       console.error('Failed to fetch financial establishment details:', error);
//       setSnackbarMessage(t('assignedFE.errorMessage'));
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   }, [t, i18n.language]);

//   // ✅ FIXED: Proper language dependency
//   useEffect(() => {
//     fetchAssignedFE();
//   }, [fetchAssignedFE]);

//   const handleViewDetails = async (row) => {
//     setModalLoading(true);
//     try {
//       const response = await axios.get(`${API_BASE_URL}/home-notification/assignedfe/${row.id}/`, {
//         params: { language: i18n.language }
//       });
//       setSelectedItem(response.data);
//       setViewModalOpen(true);
//     } catch (error) {
//       console.error('Failed to fetch details:', error);
//       setSnackbarMessage(t('assignedFE.errorMessage'));
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setModalLoading(false);
//     }
//   };

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   const handleCloseModal = () => {
//     setViewModalOpen(false);
//     setSelectedItem(null);
//   };

//   const formatList = (text) => {
//     if (!text) return '-';
//     return text.split(/[\d]\.\s+/).filter(item => item.trim()).map((item, index) => 
//       `${index + 1}. ${item.trim()}`
//     ).join('\n');
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="center" bgcolor="rgba(195, 234, 203, 0.1)" mb={2} p={2}>
//         <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
//           {t('assignedFE.heading')}
//         </Typography>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus={true}
//         enableSort={true}
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

  
//       <AFEViewModal
//         open={viewModalOpen}
//         onClose={handleCloseModal}
//         selectedItem={selectedItem}
//         modalLoading={modalLoading}
//         formatList={formatList}
//       />

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };


// import React, { useEffect, useState, useCallback } from 'react';
// import axios from 'axios';
// import {
//   Box, Typography, IconButton, Button, Dialog, DialogTitle, DialogContent,
//   DialogActions, useTheme, useMediaQuery, Paper
// } from '@mui/material';
// import { Visibility, ListAlt, Close } from '@mui/icons-material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';
// import { useTranslation } from 'react-i18next';
// import { AFEViewModal } from './assignedFEModal';

// export const AssignedFinancialEstablishmentComponent = () => {
//   const { t, i18n } = useTranslation();
//   const theme = useTheme();
//   const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

//   const [originalRows, setOriginalRows] = useState([]);
//   const [uniqueCARows, setUniqueCARows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   // Modal states
//   const [viewModalOpen, setViewModalOpen] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [modalLoading, setModalLoading] = useState(false);
  
//   // Dialog state for viewing associated FEs
//   const [feDialogOpen, setFeDialogOpen] = useState(false);
//   const [selectedCA, setSelectedCA] = useState(null);
//   const [associatedFEs, setAssociatedFEs] = useState([]);

//   // Main columns for unique CA table
//   const uniqueCAColumns = [
//     { id: 'slNo', field: 'slNo', headerName: t('assignedFE.slNo'), width: 50 },
//     { id: 'nameOfCA', field: 'nameOfCA', headerName: t('assignedFE.nameOfCA'), width: 200 },
//     { id: 'designation', field: 'designation', headerName: t('assignedFE.designation'), width: 150 },
//     { id: 'caAddress', field: 'caAddress', headerName: t('assignedFE.caAddress'), width: 250 },
//     { id: 'phNo', field: 'phNo', headerName: t('assignedFE.phNo'), width: 120 },
//     { id: 'emailLink', field: 'emailLink', headerName: t('assignedFE.email'), width: 180 },
//     // { id: 'feCount', field: 'feCount', headerName: t('assignedFE.feCount'), width: 100 },
//     {
//       id: 'viewAssociatedFE',
//       field: 'viewAssociatedFE',
//       headerName: t('assignedFE.viewAssociatedFE'),
//       width: 150,
//       renderCell: (params) => (
//         <Button
//           variant="outlined"
//           size="small"
//           startIcon={<ListAlt />}
//           onClick={() => handleViewAssociatedFE(params.row)}
//           sx={{ textTransform: 'none' }}
//         >
//           {t('assignedFE.viewFEs')}
//         </Button>
//       ),
//     },
//   ];

//   // Columns for associated FEs dialog table
//   const feDialogColumns = [
//     { id: 'slNo', field: 'slNo', headerName: t('assignedFE.slNo'), width: 50 },
//     { id: 'nameOfTheFe', field: 'nameOfTheFe', headerName: t('assignedFE.assignedFE'), width: 250 },
//     { id: 'companyPhNumber', field: 'companyPhNumber', headerName: t('assignedFE.companyPhone'), width: 120 },
//     { id: 'companyEmail', field: 'companyEmail', headerName: t('assignedFE.companyEmail'), width: 180 },
//     { id: 'addressOfCompany', field: 'addressOfCompany', headerName: t('assignedFE.address'), width: 250 },
//     {
//       id: 'viewDetails',
//       field: 'viewDetails',
//       headerName: t('assignedFE.viewDetails'),
//       width: 120,
//       renderCell: (params) => (
//         <IconButton
//           size="small"
//           color="primary"
//           onClick={() => handleViewFEDetails(params.row)}
//         >
//           <Visibility />
//         </IconButton>
//       ),
//     },
//   ];

//   const fetchAssignedFE = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(`${API_BASE_URL}/home-notification/assignedfe/`, {
//         params: { language: i18n.language }
//       });
      
//       const apiData = response.data.map((item, index) => ({
//         id: item.id || index,
//         slNo: index + 1,
//         nameOfCA: item.name_of_ca,
//         designation: item.designation,
//         caAddress: item.ca_address || '',
//         nameOfTheFe: item.name_of_fe,
//         phNo: item.ph_number,
//         emailLink: item.email,
//         groupOfEntities: item.group_of_entities || '',
//         nameOfDirectors: item.name_of_directors || '',
//         crimeNo: item.crime_no || '',
//         firNo: item.fir_no || '',
//         companyEmail: item.company_email || '',
//         companyPhNumber: item.company_ph_number || '',
//         addressOfCompany: item.address_of_company || '',
//         viewDetailsLink: item.link || '',
//         // Add CA identifier for grouping
//         caIdentifier: `${item.name_of_ca}_${item.designation}_${item.email}`
       
//       }));
      
//       setOriginalRows(apiData);
//       processUniqueCAs(apiData);
      
//       setSnackbarMessage(t('assignedFE.successMessage'));
//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//     } catch (error) {
//       console.error('Failed to fetch financial establishment details:', error);
//       setSnackbarMessage(t('assignedFE.errorMessage'));
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   }, [t, i18n.language]);

//   const processUniqueCAs = (data) => {
//     // Group by CA identifier
//     const caGroups = {};
    
//     data.forEach(item => {
//       const key = item.caIdentifier;
//       if (!caGroups[key]) {
//         caGroups[key] = {
//           caData: {
//             id: item.id,
//             nameOfCA: item.nameOfCA,
//             designation: item.designation,
//             caAddress: item.caAddress,
//             phNo: item.phNo,
//             emailLink: item.emailLink,
//             caIdentifier: item.caIdentifier
//           },
//           feList: []
//         };
//       }
//       // Add FE to this CA's list
//       caGroups[key].feList.push({
//         ...item,
//         feSlNo: caGroups[key].feList.length + 1
//       });
//     });
    
//     // Convert to array for table rows
//     const uniqueCAArray = Object.values(caGroups).map((group, index) => ({
//       id: index + 1,
//       slNo: index + 1,
//       nameOfCA: group.caData.nameOfCA,
//       designation: group.caData.designation,
//       caAddress: group.caData.caAddress,
//       phNo: group.caData.phNo,
//       emailLink: group.caData.emailLink,
//       feCount: group.feList.length,
//       caIdentifier: group.caData.caIdentifier,
//       _allFEData: group.feList // Store all FE data for this CA
//     }));
    
//     setUniqueCARows(uniqueCAArray);
//   };

//   useEffect(() => {
//     fetchAssignedFE();
//   }, [fetchAssignedFE]);

//   const handleViewAssociatedFE = (caRow) => {
//     setSelectedCA(caRow);
//     // Get all FEs for this CA
//     const feData = originalRows.filter(row => 
//       `${row.nameOfCA}_${row.designation}_${row.emailLink}` === caRow.caIdentifier
//     ).map((fe, index) => ({
//       ...fe,
//       slNo: index + 1
//     }));
    
//     setAssociatedFEs(feData);
//     setFeDialogOpen(true);
//   };

//   const handleViewFEDetails = async (feRow) => {
//     setModalLoading(true);
//     try {
//       const response = await axios.get(`${API_BASE_URL}/home-notification/assignedfe/${feRow.id}/`, {
//         params: { language: i18n.language }
//       });
//       setSelectedItem(response.data);
//       setViewModalOpen(true);
//     } catch (error) {
//       console.error('Failed to fetch FE details:', error);
//       setSnackbarMessage(t('assignedFE.errorMessage'));
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setModalLoading(false);
//     }
//   };

//   const handleCloseFEDialog = () => {
//     setFeDialogOpen(false);
//     setSelectedCA(null);
//     setAssociatedFEs([]);
//   };

//   const handleCloseModal = () => {
//     setViewModalOpen(false);
//     setSelectedItem(null);
//   };

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   const formatList = (text) => {
//     if (!text) return '-';
//     return text.split(/[\d]\.\s+/).filter(item => item.trim()).map((item, index) => 
//       `${index + 1}. ${item.trim()}`
//     ).join('\n');
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="center" bgcolor="rgba(195, 234, 203, 0.1)" mb={2} p={2}>
//         <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
//           {t('assignedFE.heading')}
//         </Typography>
//       </Box>

//       {/* <Typography variant="body1" sx={{ p: 2, fontStyle: 'italic', color: 'text.secondary' }}>
//         {t('assignedFE.uniqueCANote') || 'Showing unique Chartered Accountants with their associated Financial Establishments'}
//       </Typography> */}

//       <TableComponent
//         columns={uniqueCAColumns}
//         rows={uniqueCARows}
//         manageColumnStatus={true}
//         enableSort={true}
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       {/* Dialog for viewing associated FEs */}
//       <Dialog
//         open={feDialogOpen}
//         onClose={handleCloseFEDialog}
//         fullScreen={fullScreen}
//         maxWidth="xl"
//         fullWidth
//         PaperProps={{
//           sx: {
//             maxHeight: '90vh',
//             height: '90vh',
//             width: '95vw',
//             maxWidth: '95vw',
//             m: 1
//           }
//         }}
//       >
//         <DialogTitle sx={{ 
//           backgroundColor: '#2e7d32',
//           color: 'white',
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           py: 2
//         }}>
//           <Box>
//             <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//               {selectedCA ? `${t('assignedFE.associatedFEFor')}: ${selectedCA.nameOfCA}` : t('assignedFE.associatedFE')}
//             </Typography>
//             <Box sx={{ display: 'flex', gap: 3, mt: 1 }}>
//               {/* <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
//                 {t('assignedFE.designation')}: {selectedCA?.designation}
//               </Typography> */}
//               {/* <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
//                 {t('assignedFE.email')}: {selectedCA?.emailLink}
//               </Typography> */}
//               <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)', fontWeight: 'bold' }}>
//                 {t('assignedFE.totalFE')}: {associatedFEs.length}
//               </Typography>
//             </Box>
//           </Box>
//           <Box>
//             <IconButton 
//               onClick={handleCloseFEDialog} 
//               sx={{ color: 'white' }}
//               size="large"
//             >
//               <Close />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent sx={{ p: 3 }}>
//           <Paper elevation={0} sx={{ height: '100%', width: '100%' }}>
//             <TableComponent
//               columns={feDialogColumns}
//               rows={associatedFEs}
//               manageColumnStatus={true}
//               enableSort={true}
//               sx={{
//                 '& .MuiDataGrid-columnHeaders': {
//                   backgroundColor: '#388e3c',
//                   color: '#fff',
//                   fontWeight: 'bold',
//                 },
//                 height: 'calc(90vh - 180px)',
//                 width: '100%'
//               }}
//             />
//           </Paper>
//         </DialogContent>
//         <DialogActions sx={{ p: 2, backgroundColor: '#f5f5f5' }}>
//           <Button 
//             onClick={handleCloseFEDialog} 
//             variant="contained" 
//             color="primary"
//             startIcon={<Close />}
//           >
//             {t('common.close')}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* FE Details Modal - Larger version */}
//       <Dialog
//         open={viewModalOpen}
//         onClose={handleCloseModal}
//         fullScreen={fullScreen}
//         maxWidth="lg"
//         fullWidth
//         PaperProps={{
//           sx: {
//             maxHeight: '90vh',
//             height: '90vh',
//             width: fullScreen ? '100vw' : '85vw',
//             maxWidth: fullScreen ? '100vw' : '85vw',
//             m: 1
//           }
//         }}
//       >
//         {modalLoading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
//             <LoadingSpinner size={40} />
//           </Box>
//         ) : (
//           <>
//             <DialogTitle sx={{ 
//               backgroundColor: '#1976d2',
//               color: 'white',
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               py: 2
//             }}>
//               <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
//                 {t('assignedFE.feDetails')}
//               </Typography>
//               <IconButton 
//                 onClick={handleCloseModal} 
//                 sx={{ color: 'white' }}
//                 size="large"
//               >
//                 <Close />
//               </IconButton>
//             </DialogTitle>
//             <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
//               <AFEViewModal
//                 open={viewModalOpen}
//                 onClose={handleCloseModal}
//                 selectedItem={selectedItem}
//                 modalLoading={modalLoading}
//                 formatList={formatList}
//                 isEmbedded={true}
//               />
//             </DialogContent>
//           </>
//         )}
//       </Dialog>

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };


// final
import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import {
  Box, Typography, IconButton, Button, Dialog, DialogTitle, DialogContent,
  DialogActions, useTheme, useMediaQuery, Paper
} from '@mui/material';
import { Visibility, ListAlt, Close } from '@mui/icons-material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';
import { useTranslation } from 'react-i18next';
import { AFEViewModal } from './assignedFEModal';

export const AssignedFinancialEstablishmentComponent = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [originalRows, setOriginalRows] = useState([]);
  const [uniqueCARows, setUniqueCARows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  // Modal states
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  
  // Dialog state for viewing associated FEs
  const [feDialogOpen, setFeDialogOpen] = useState(false);
  const [selectedCA, setSelectedCA] = useState(null);
  const [associatedFEs, setAssociatedFEs] = useState([]);

  // Main columns for unique CA table
  const uniqueCAColumns = [
    { id: 'slNo', field: 'slNo', headerName: t('assignedFE.slNo'), width: 50 },
    { id: 'nameOfCA', field: 'nameOfCA', headerName: t('assignedFE.nameOfCA'), width: 200 },
    { id: 'designation', field: 'designation', headerName: t('assignedFE.designation'), width: 150 },
    { id: 'caAddress', field: 'caAddress', headerName: t('assignedFE.caAddress'), width: 250 },
    { id: 'phNo', field: 'phNo', headerName: t('assignedFE.phNo'), width: 120 },
    { id: 'emailLink', field: 'emailLink', headerName: t('assignedFE.email'), width: 180 },
    {
      id: 'viewAssociatedFE',
      field: 'viewAssociatedFE',
      headerName: t('assignedFE.viewAssociatedFE'),
      width: 150,
      renderCell: (params) => (
        <Button
          variant="outlined"
          size="small"
          startIcon={<ListAlt />}
          onClick={() => handleViewAssociatedFE(params.row)}
          sx={{ textTransform: 'none' }}
        >
          {t('assignedFE.viewFEs')}
        </Button>
      ),
    },
  ];

  // Columns for associated FEs dialog table
  const feDialogColumns = [
    { id: 'slNo', field: 'slNo', headerName: t('assignedFE.slNo'), width: 50 },
    { id: 'nameOfTheFe', field: 'nameOfTheFe', headerName: t('assignedFE.assignedFE'), width: 250 },
    { id: 'companyPhNumber', field: 'companyPhNumber', headerName: t('assignedFE.companyPhone'), width: 120 },
    { id: 'companyEmail', field: 'companyEmail', headerName: t('assignedFE.companyEmail'), width: 180 },
    { id: 'addressOfCompany', field: 'addressOfCompany', headerName: t('assignedFE.address'), width: 250 },
    {
      id: 'viewDetails',
      field: 'viewDetails',
      headerName: t('assignedFE.viewDetails'),
      width: 120,
      renderCell: (params) => (
        <IconButton
          size="small"
          color="primary"
          onClick={() => handleViewFEDetails(params.row)}
        >
          <Visibility />
        </IconButton>
      ),
    },
  ];

  const fetchAssignedFE = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/home-notification/assignedfe/`, {
        params: { language: i18n.language }
      });
      
      const apiData = response.data.map((item, index) => ({
        id: item.id || index,
        slNo: index + 1,
        nameOfCA: item.name_of_ca,
        designation: item.designation,
        caAddress: item.ca_address || '',
        nameOfTheFe: item.name_of_fe,
        phNo: item.ph_number,
        emailLink: item.email,
        groupOfEntities: item.group_of_entities || '',
        nameOfDirectors: item.name_of_directors || '',
        crimeNo: item.crime_no || '',
        firNo: item.fir_no || '',
        companyEmail: item.company_email || '',
        companyPhNumber: item.company_ph_number || '',
        addressOfCompany: item.address_of_company || '',
        viewDetailsLink: item.link || '',
        // Add CA identifier for grouping - only by name (remove spaces)
        caIdentifier: item.name_of_ca ? item.name_of_ca.replace(/\s+/g, '').toLowerCase() : ''
      }));
      
      setOriginalRows(apiData);
      processUniqueCAs(apiData);
      
      setSnackbarMessage(t('assignedFE.successMessage'));
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
    } catch (error) {
      console.error('Failed to fetch financial establishment details:', error);
      setSnackbarMessage(t('assignedFE.errorMessage'));
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  }, [t, i18n.language]);

  const processUniqueCAs = (data) => {
    // Group by CA name only (ignoring spaces)
    const caGroups = {};
    
    data.forEach(item => {
      const key = item.caIdentifier;
      if (!key) return; // Skip items without CA name
      
      if (!caGroups[key]) {
        // For the first FE for this CA, use its CA details
        caGroups[key] = {
          caData: {
            id: item.id,
            nameOfCA: item.nameOfCA,
            designation: item.designation,
            caAddress: item.caAddress,
            phNo: item.phNo,
            emailLink: item.emailLink,
            caIdentifier: item.caIdentifier
          },
          feList: []
        };
      }
      // Add FE to this CA's list
      caGroups[key].feList.push({
        ...item,
        feSlNo: caGroups[key].feList.length + 1
      });
    });
    
    // Convert to array for table rows
    const uniqueCAArray = Object.values(caGroups).map((group, index) => ({
      id: index + 1,
      slNo: index + 1,
      nameOfCA: group.caData.nameOfCA,
      designation: group.caData.designation,
      caAddress: group.caData.caAddress,
      phNo: group.caData.phNo,
      emailLink: group.caData.emailLink,
      feCount: group.feList.length,
      caIdentifier: group.caData.caIdentifier,
      _allFEData: group.feList // Store all FE data for this CA
    }));
    
    setUniqueCARows(uniqueCAArray);
  };

  useEffect(() => {
    fetchAssignedFE();
  }, [fetchAssignedFE]);

  const handleViewAssociatedFE = (caRow) => {
    setSelectedCA(caRow);
    // Get all FEs for this CA (group by name without spaces)
    const feData = originalRows.filter(row => {
      const rowCAIdentifier = row.nameOfCA ? row.nameOfCA.replace(/\s+/g, '').toLowerCase() : '';
      return rowCAIdentifier === caRow.caIdentifier;
    }).map((fe, index) => ({
      ...fe,
      slNo: index + 1
    }));
    
    setAssociatedFEs(feData);
    setFeDialogOpen(true);
  };

  const handleViewFEDetails = async (feRow) => {
    setModalLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/home-notification/assignedfe/${feRow.id}/`, {
        params: { language: i18n.language }
      });
      setSelectedItem(response.data);
      setViewModalOpen(true);
    } catch (error) {
      console.error('Failed to fetch FE details:', error);
      setSnackbarMessage(t('assignedFE.errorMessage'));
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setModalLoading(false);
    }
  };

  const handleCloseFEDialog = () => {
    setFeDialogOpen(false);
    setSelectedCA(null);
    setAssociatedFEs([]);
  };

  const handleCloseModal = () => {
    setViewModalOpen(false);
    setSelectedItem(null);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const formatList = (text) => {
    if (!text) return '-';
    return text.split(/[\d]\.\s+/).filter(item => item.trim()).map((item, index) => 
      `${index + 1}. ${item.trim()}`
    ).join('\n');
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="center" bgcolor="rgba(195, 234, 203, 0.1)" mb={2} p={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          {t('assignedFE.heading')}
        </Typography>
      </Box>

      <TableComponent
        columns={uniqueCAColumns}
        rows={uniqueCARows}
        manageColumnStatus={true}
        enableSort={true}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      {/* Dialog for viewing associated FEs */}
      <Dialog
        open={feDialogOpen}
        onClose={handleCloseFEDialog}
        fullScreen={fullScreen}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: '90vh',
            height: '90vh',
            width: '95vw',
            maxWidth: '95vw',
            m: 1
          }
        }}
      >
        <DialogTitle sx={{ 
          backgroundColor: '#2e7d32',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 2
        }}>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              {selectedCA ? `${t('assignedFE.associatedFEFor')}: ${selectedCA.nameOfCA}` : t('assignedFE.associatedFE')}
            </Typography>
            <Box sx={{ display: 'flex', gap: 3, mt: 1 }}>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)', fontWeight: 'bold' }}>
                {t('assignedFE.totalFE')}: {associatedFEs.length}
              </Typography>
            </Box>
          </Box>
          <Box>
            <IconButton 
              onClick={handleCloseFEDialog} 
              sx={{ color: 'white' }}
              size="large"
            >
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Paper elevation={0} sx={{ height: '100%', width: '100%' }}>
            <TableComponent
              columns={feDialogColumns}
              rows={associatedFEs}
              manageColumnStatus={true}
              enableSort={true}
              sx={{
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#388e3c',
                  color: '#fff',
                  fontWeight: 'bold',
                },
                height: 'calc(90vh - 180px)',
                width: '100%'
              }}
            />
          </Paper>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f5f5f5' }}>
          <Button 
            onClick={handleCloseFEDialog} 
            variant="contained" 
            color="primary"
            startIcon={<Close />}
          >
            {t('common.close')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* FE Details Modal - Larger version */}
      <Dialog
        open={viewModalOpen}
        onClose={handleCloseModal}
        fullScreen={fullScreen}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: '90vh',
            height: '90vh',
            width: fullScreen ? '100vw' : '85vw',
            maxWidth: fullScreen ? '100vw' : '85vw',
            m: 1
          }
        }}
      >
        {modalLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <LoadingSpinner size={40} />
          </Box>
        ) : (
          <>
            <DialogTitle sx={{ 
              backgroundColor: '#1976d2',
              color: 'white',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              py: 2
            }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                {t('assignedFE.feDetails')}
              </Typography>
              <IconButton 
                onClick={handleCloseModal} 
                sx={{ color: 'white' }}
                size="large"
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
              <AFEViewModal
                open={viewModalOpen}
                onClose={handleCloseModal}
                selectedItem={selectedItem}
                modalLoading={modalLoading}
                formatList={formatList}
                isEmbedded={true}
              />
            </DialogContent>
          </>
        )}
      </Dialog>

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};